import React, { useState, useEffect } from "react";
import { isUiEvent } from "../logic/WidgetUtils";

// Externals
import cn from "classnames";

// DevExtreme components
import { CheckBox } from 'devextreme-react/check-box';

// Component styles
import classes from "./Checkbox2StatesWidget.module.scss"; 

const EMPTY = null;

export function Checkbox2StatesWidget(props) {
  const { ui, data, config, writeBack } = props;
  const [localContent, setLocalContent] = useState(EMPTY);

  let widgetId = ui.id;
  let stringContent = localContent !== EMPTY ? localContent : data && data.content ? data.content.toLowerCase() : "null";
  let content = (stringContent === "true");
  let label = config ? config.CheckboxLabel : "";
  let disabled = ui.readonly || (data && data.readonly);

  useEffect(() => {
    //console.log("Checkbox2StatesWidget data of " + ui.id + ": ", data);
    setLocalContent(EMPTY);
  }, [data]);

  const setContent = (args) => {
    if (!isUiEvent(args)) return;
    let value = args.value;
    let realValue = value === undefined ? "null" : value.toString();
    setLocalContent(realValue);
    writeBack(realValue, true);
  };

  return (
    <CheckBox
      className={cn(classes.checkBox, disabled ? classes.disabled : "")}
      id={widgetId}
      value={content}
      text={label}
      onValueChanged={e => setContent(e)}
      disabled={disabled}
      height={ui.controlHeight + "em"}
    />
  );
}